import { SubActivityState } from './types';

const state = (): SubActivityState => {
  return {
    subActivities: [],
  };
};

export default state;
